import {DateTime} from "luxon";
import {getCurrentIsoTimestamp} from "@vesta/global-common-typescript/utilities/utilities";

export const nRows = 12;
export const nCols = 12;
export const elementAspectRatio = 1.625;
export const editGap = 0;
export const viewGap = 0;

export const dotSize = 2;

export const addWidgetMenuColSpan = 4;

export const resizeHandleWidth = 3;
export const resizeHandleTapTargetWidth = 8;
export const resizeHandleTapTargetOutsideOffset = 1.5;
// export const cornerResizeHandleLength = elementSize / 4;
// export const cornerResizeHandleLength = 16;
export const resizeHandleColor = "#ffffff";

// Gap between resize handles and main moving div
// export const resizeMoveGap = 16;
export const resizeMoveGap = 0;

export const leftPaneWidth = 320;

export const dashedOutlineWidth = 1;
// TODO: Remove from here?
export const dashedOutlineColor = "#2045d8";

// Related to scaling: fonts, bar widths etc.
export const referenceElementWidth = 33;
export const referenceFontSize = 16;
export const referenceBarWidth = 8;

// Size of everything in one report cell, scale up from here
export const newReferenceElementWidth = 75;
export const newReferenceElementHeight = 45;
export const newReferenceFontSize = 3;
export const newReferenceBarWidth = 2;

export const dateColumn = "date";

export const startDateDefault = DateTime.fromISO(
    getCurrentIsoTimestamp(),
).minus({
    month: 1,
});
export const endDateDefault = DateTime.now();

export const minimumRowSpan = 1;
export const minimumColSpan = 1;
export const slugSeparator = "-";
export const reportSlugSeparator = "_"; // Temporarily adding back for migration
export const widgetBottomBarHeightInRem = 1;
export const widgetTopBarHeightInRem = 2;
export const widgetTopBarHeightInRemRawWidgets = 1;
export const widgetTopAndBottomBarGap = 0.5;
export const istIanaTimezoneKey = "IN";

export const defaultThickness = 8;
export const minimumDraggableArea = 0.5;
export const defaultCornerLengthPercentage = 0.25;
